import { render, staticRenderFns } from "./ModalErrorMove.vue?vue&type=template&id=53a92a62"
import script from "./ModalErrorMove.vue?vue&type=script&lang=js"
export * from "./ModalErrorMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports